import React from 'react';
import InputField from '../../common/InputField';
import { useTranslation } from "react-i18next";
import { BiPlusCircle, BiMinusCircle }   from "react-icons/bi";
import { IfDate } from '../../cards/DatePicker'
import { DateFormat } from "../../../config/helper";
import { CALCULATION_TYPE_VALUES } from '../../../config/constant';
import IfSubScheme from './IfSubScheme';

const IfDisbursalCard = (props) => {
    
    const {element,tempErrors,element_index,element_key,minMaxDate} = props;
    const {scheme_duration} = props?.incentive_config
    const {conversion_rate} = props.incentive_config
    const { t } = useTranslation("common");
    const isPercentage = 1;
    props.element.conversion_rate = conversion_rate;

    const onChange = (event) => {
        let { name, value } = event.target;
        const validated = element.form_config.AUM_EXIT ? value.match(/^(\d*\.{0,1}\d{0,5}$)/) : value.match(/^(\d*\.{0,1}\d{0,2}$)/); 
        if(validated){
            props.onChange(name, value, '', props.element)
        } 
    }

    const onChangeMinMax = (event) => {
        let { name, value } = event.target;  
            const validated = value.match(/^(\d*\.{0,1}\d{0,2}$)/);  
            if(validated && value <= 999){
                props.onChange(name, value, '', props.element)
            }
    }
    const addMore = (e,index,type)=>{ 
        let addStatus=true;
        if(addStatus){
            e.stopPropagation(); 
            let params = {
                key: index+1,
                index :props.element_index,
                type:type,
                scheme:props.element.scheme_type_id
            } 
            props.addMoreIncentive(params)
        }
    }
    const removeMore = (e,index,data,type)=>{  
        e.stopPropagation();
        let params = {
            key: index,
            index : props.element_index,
            type:type,
            scheme: props.element.scheme_type_id,
            is_deleted : (data.id)? data.id : false
        }  
        props.removeMoreIncentive(params)
    }

    const onChangeDate = (name,date)=>{
        props.onChange(name, DateFormat(date), '', props.element)
    } 

    const minDate = minMaxDate?.minDate ? minMaxDate?.minDate : scheme_duration?.find(ele => ele.value === element?.scheme_duration)?.start;
    const maxDate = minMaxDate?.maxDate ? minMaxDate?.maxDate : scheme_duration?.find(ele => ele.value === element?.scheme_duration)?.end;
  
    return (
        <React.Fragment>
             <div className='extra-incentive-outer add-incentive-table'> 
                <table>
                    <thead>
                        <tr>
                            {
                                element.form_config.AUM_EXIT &&
                                <>
                                    <th>{t('IF.FORM.MIN_AUM')}
                                        <span>
                                        {t('IF.FORM.ACH')}
                                        </span>
                                    </th>
                                    <th>{t('IF.FORM.MAX_AUM')}
                                        <span>{t('IF.FORM.ACH')}</span>
                                    </th>
                                </>
                            }

                            {
                                element.form_config.FRESH_GMV &&
                                <>
                                    <th>{t('IF.FORM.MIN_GMV')}
                                        <span>
                                        {t('IF.FORM.ACH')}
                                        </span>
                                    </th>
                                    <th>{t('IF.FORM.MAX_GMV')}
                                        <span>{t('IF.FORM.ACH')}</span>
                                    </th>
                                </>
                            }

                            {
                                element.form_config.ACTIVATION &&
                                <>
                                    <th>{t('IF.FORM.MIN_ACTIVATION')}
                                        <span>
                                        {t('IF.FORM.ACTIVATED_PERCENT')}
                                        </span>
                                    </th>
                                    <th>{t('IF.FORM.MAX_ACTIVATION')}
                                        <span>{t('IF.FORM.ACTIVATED_PERCENT')}</span>
                                    </th>
                                </>
                            }

                            {
                                element.form_config.NCL &&
                                <>
                                    <th>{t('IF.FORM.MIN_NCL_PERCENTAGE')}
                                        <span>
                                        {t('IF.FORM.NCL_PERCENTAGE')}
                                        </span>
                                    </th>
                                    <th>{t('IF.FORM.MAX_NCL_PERCENTAGE')}
                                        <span>{t('IF.FORM.NCL_PERCENTAGE')}</span>
                                    </th>
                                </>
                            }

                          { element.form_config.AUM_EXIT  &&
                            <>
                            <th>{ element?.calculation_type?.toLowerCase() === CALCULATION_TYPE_VALUES.PERCENTAGE ? t('IF.FORM.PER_INC_AMT') : t('IF.FORM.INC_AMT')}
                            <span> {t('FORM.PER_MONTH')}  
                            </span>
                            </th> 
                          </> }

                          { element.form_config.ACTIVATION  &&
                            <>
                            <th>{t('IF.FORM.INC_AMT')}
                            <span> {t('FORM.PER_MONTH')}  
                            </span>
                            </th> 
                          </> }

                          { element.form_config.FRESH_GMV  &&
                            <>
                                <th>{ element?.calculation_type?.toLowerCase() === CALCULATION_TYPE_VALUES.PERCENTAGE ? t('IF.FORM.PER_INC_AMT') : t('IF.FORM.INC_AMT_IDR')}
                                <span> {t('FORM.PER_MONTH')}  
                                </span>
                                </th> 
                                {
                                    element?.calculation_type?.toLowerCase() === CALCULATION_TYPE_VALUES.FLAT && 
                                    <>
                                        <th>{t('IF.FORM.INC_AMT_USD')}
                                        <span> {t('FORM.PER_MONTH')}  
                                        </span>
                                        </th> 
                                    </>
                                }
                            </> 
                          }

                          { element.form_config.NCL  &&
                            <>
                            <th>{t('IF.FORM.NCL_PERCENT_REMOVAL')}
                            <span> {t('FORM.PER_MONTH')}  
                            </span>
                            </th> 
                          </> }
                        </tr>
                    </thead>
                    <tbody>
                        {element && element[element_key] && element[element_key].length > 0 && element[element_key].map((data, index) => (
                            <tr key={(element.id)?element.id+'_'+element_index+'_'+index: element_index+'_'+index}>
                                <td>
                                    {
                                        element.form_config.MIN_DISBURSAL &&  
                                        <> 
                                            <fieldset className="m-sm-r">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "min_disb_per_" + index,
                                                            type: "text",
                                                            name: "min_disb_per_" + index,
                                                            placeholder: " ",
                                                            value:data.min_disb_per ,
                                                            className: "form-input",
                                                            disabled: element.is_expired || false
                                                        }}
                                                        onChange={(e, i, q, u) => onChangeMinMax(e, i, q, u)}
                                                    />
                                                </div>
                                                {
                                                    (tempErrors && tempErrors["min_disb_per_" + index]) ? <span className="error show">{tempErrors["min_disb_per_" + index]}</span> : <span>&nbsp;</span>
                                                }
                                            </fieldset>
                                        </>
                                    }
                                    {
                                        element.form_config.TARGET &&
                                        <>
                                        <fieldset className="m-sm-r">
                                            <div className="material">
                                                <InputField
                                                    inputProps={{
                                                        id: "target_amount_" + index,
                                                        type: "text",
                                                        name: "target_amount_" + index,
                                                        placeholder: " ",
                                                        value:data.target_amount || '',
                                                        className: "form-input",
                                                        disabled: element.is_expired || false,
                                                        percentage: isPercentage
                                                    }}
                                                    onChange={(e, i, q, u) => onChange(e, i, q, u)}
                                                />
                                            </div>
                                            {
                                                (tempErrors && tempErrors["target_amount_" + index]) ? <span className="error show">{tempErrors["target_amount_" + index]}</span> : <span>&nbsp;</span>
                                            }
                                        </fieldset>
                                        </>
                                    }

                                </td>

                               
                                <td>
                                    {
                                        element.form_config.MAX_DISBURSAL && 
                                        <>
                                            <fieldset className="m-sm-r">
                                                <div className="material">
                                                    <InputField
                                                        inputProps={{
                                                            id: "max_disb_per_" + index,
                                                            type: "text",
                                                            name: "max_disb_per_" + index,
                                                            placeholder: " ",
                                                            value:data.max_disb_per,
                                                            className: "form-input",
                                                            disabled: element.is_expired || false
                                                        }}
                                                        onChange={(e, i, q, u) => onChangeMinMax(e, i, q, u)}
                                                    />
                                                </div>
                                                {
                                                    (tempErrors && tempErrors["max_disb_per_" + index]) ? <span className="error show">{tempErrors["max_disb_per_" + index]}</span> : <span>&nbsp;</span>
                                                }
                                            </fieldset>
                                        </>
                                    }
                                    {
                                        element.form_config.IF_DATE && 
                                        <>
                                        <fieldset className="m-sm-r ifDate">
                                            <IfDate 
                                                element={element} 
                                                dateFormat="dd-MM-yyyy" 
                                                label=""
                                                onChange={(e) => {onChangeDate("if_date_"+index,e) }} 
                                                minDate={new Date(minDate)}
                                                maxDate={new Date(maxDate)}
                                                selected={data.if_date || null} />
                                            
                                            {
                                                (tempErrors && tempErrors["if_date_" + index]) ? <span className="error show">{tempErrors["if_date_" + index]}</span> : <span>&nbsp;</span>
                                            }
                                        </fieldset> 
                                        </>
                                    }
                                </td>
  
                                <td>
                                    <fieldset>
                                        <div className="material m-sm-r">
                                            <InputField
                                                inputProps={{
                                                    id: "incentive_amount_" + index,
                                                    type: "text",
                                                    name: "incentive_amount_" + index,
                                                    placeholder: " ",
                                                    value:data.incentive_amount,
                                                    className: "form-input",
                                                    disabled: element.is_expired || false
                                                }}
                                                onChange={(e, i, q, u) => onChange(e, i, q, u)}
                                            />
                                        </div>
                                        {
                                            (tempErrors && tempErrors["incentive_amount_" + index]) ? <span className="error show">{tempErrors["incentive_amount_" + index]}</span> : <span>&nbsp;</span>
                                        }
                                    </fieldset>
                                </td>
  
                                { (element?.form_config?.FRESH_GMV && element?.calculation_type?.toLowerCase() === CALCULATION_TYPE_VALUES.FLAT) && 
                                    <td>
                                        <fieldset>
                                            <div className="material m-sm-r">
                                                <InputField
                                                    inputProps={{
                                                        id: "incentive_amount_usd_" + index,
                                                        type: "text",
                                                        name: "incentive_amount_usd_" + index,
                                                        placeholder: " ",
                                                        value:data.incentive_amount_usd,
                                                        className: "form-input",
                                                        disabled: element.is_expired || false
                                                    }}
                                                    onChange={(e, i, q, u) => onChange(e, i, q, u)}
                                                />
                                            </div>
                                            {
                                                (tempErrors && tempErrors["incentive_amount_usd_" + index]) ? <span className="error show">{tempErrors["incentive_amount_usd_" + index]}</span> : <span>&nbsp;</span>
                                            }
                                        </fieldset>
                                    </td>
                                }

                                {   
                                    element[element_key] && (
                                        (index ===0)?
                                        <td>
                                         {
                                           (element.is_expired)?<span className="add-minus"><BiPlusCircle size="1.4em"/></span>:<span className="add-minus" onClick={(e)=>addMore(e,index,element_key)}><BiPlusCircle size="1.4em"/> </span>
                                         }   
                                        
                                        </td>: 
                                        <td>
                                            {
                                               (element.is_expired)?<span className="add-minus"> <BiMinusCircle size="1.4em"/></span>: <span className="add-minus" onClick={(e)=>removeMore(e,index,data,element_key)}> <BiMinusCircle size="1.4em"/></span>
                                            }
                                        
                                    </td>
                                    ) 
                                }
                                
                            </tr>
                        ))}
                    </tbody>
                </table>
                {element.form_config.hasOwnProperty("SUB_SCHEMES") ? (
                    <IfSubScheme scheme={element} onChange={props.onChange} errors={tempErrors} />
                ) : null}
                </div>
        </React.Fragment>
    );

}
export default IfDisbursalCard;